module.exports = __webpack_public_path__ + "img/4.b2e4de2f.png";